module.exports = __webpack_public_path__ + "static/media/skin-diseases-icon.074ce8d5.svg";